module.exports = __webpack_public_path__ + "static/media/SF-14-A.e3a22fa0.mp3";